export const ApplicationAndModules = "Application & Modules";
export const Roles = "Roles";
export const UserRoles = "User Roles";
export const UserLog = "User Log";
export const CompanyProfile = "Company Profile";